// extracted by mini-css-extract-plugin
module.exports = {"image-rounded":"agent-control-compliance-section_image-rounded__0tgdp"};